export default "f94d683845f55002.svg"